import React from 'react';
import { getCategoryLabel } from '../content/categories';

const palette = {
  'À la une': 'bg-indigo-100 text-indigo-700',
  IA: 'bg-violet-100 text-violet-700',
  'Business & opportunités': 'bg-blue-100 text-blue-700',
  'Aides & financements': 'bg-emerald-100 text-emerald-700',
  'Bons plans': 'bg-amber-100 text-amber-700',
  'Marketing & SEO': 'bg-cyan-100 text-cyan-700',
  'Analyses & opinions': 'bg-rose-100 text-rose-700',
  'Actu rapide': 'bg-slate-200 text-slate-700'
};

const CategoryBadge = ({ category, className = '' }) => {
  const normalizedLabel = palette[category] ? category : getCategoryLabel(category);
  const colors = palette[normalizedLabel] || 'bg-slate-100 text-slate-700';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider ${colors} ${className}`}
    >
      {normalizedLabel}
    </span>
  );
};

export default CategoryBadge;
